module.exports = __webpack_public_path__ + "static/media/bootstrap.9781c375.png";